import type { UnionOfPropertyTypes } from '@backmarket/utils/object/UnionOfPropertyTypes'

export const KlarnaPlacementKey = {
  PRODUCT: 'credit-promotion-auto-size',
  SITEWIDE: 'top-strip-promotion-auto-size',
} as const

export type KlarnaPlacementKey = UnionOfPropertyTypes<typeof KlarnaPlacementKey>
